import React from 'react'
import {Route, IndexRoute} from 'react-router'
import Loadable from 'react-loadable'
import Loading from 'App/components/RouteLoading'

const comp = loader => Loadable({loader, loading: Loading})

export default (
  <Route path="kyc" component={comp(() => import('./Layout'))}>
    <IndexRoute component={comp(() => import('./Main'))} />
    <Route path="front" component={comp(() => import('./Front'))} />
    <Route path="back" component={comp(() => import('./Back'))} />
    <Route path="liveness" component={comp(() => import('./Liveness'))} />
    <Route path="finish" component={comp(() => import('./Finish'))} />
    <Route path="error" component={comp(() => import('./Error'))} />
    <Route path="camera" component={comp(() => import('./Camera'))} />
    <Route onUpdate={() => window.scrollTo(0, 0)} path=":userId/:token" component={comp(() => import('./Landing'))} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/App/Pages/Kyc/index.js